'use strict';
const _ = require('underscore');
const StateFactory = require('process/domain/factory/action/state');
const Transition = require('process/domain/entity/action/transition');
const ActionType = require('process/domain/entity/action/type');

class Factory {
    constructor(project) {
        this._project = project;
    }

    build(json, repository) {
        return new Promise((resolve, reject) => {
            json._project = this._project;
            json._repository = repository;
            json._transitions = _.map(json.transitions, t => {
                return new Transition(t);
            });

            let p = new ActionType(json);

            const stateFactory = new StateFactory(this._project);
            Promise.all(
                _.map(json.states, s => stateFactory.build(s))
            ).then(values => {
                p.set({_states: values});

                resolve(p);
            }, reject);
        });
    }
}

module.exports = Factory;



// WEBPACK FOOTER //
// ./process/domain/factory/action/type.js